import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';

@Injectable()
export class GenKullaniciService {
  public isPersonel!: boolean;
  public isActive!: boolean;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public codeField:string="Kod"
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(isPersonel: boolean, isActive: boolean,codeField:string, isReadOnly:boolean, isBindCheck:boolean ){
    this.isPersonel = isPersonel;
    this.isActive = isActive;
    this.codeField = codeField
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code: number,control:any, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
      dataSource.select();
      const filterArr = [];
      if (code) filterArr.push([this.codeField, '=', code]);
      if (filterArr.length > 0) dataSource.filter(filterArr);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
      dataSource.select();
      const filterArr = [];
      if (code) filterArr.push([this.codeField, '=', code]);
      if (this.isActive && !isSetData) filterArr.push(['AktifEh', '=', 'E']);
      if (filterArr.length > 0) dataSource.filter(filterArr);
    }
    return dataSource;
  }
}
